import { SELECTABLE_STOCK_STATUSES } from "@features/product/config/const";

export function isSelectableStock(stock: number) {
  return SELECTABLE_STOCK_STATUSES.includes(stock);
}
